// extracted by mini-css-extract-plugin
export default {"root":"menu_root__6wMl7","dropdown":"menu_dropdown__HGPSv","item":"menu_item__CaTbl","itemLabel":"menu_itemLabel__XLLpq"};